<template>
    
	<div>
		<div :id="maxscrollTop?'commonGoTopNav':''">
			<div class="commonNavBox breadcrumb" >
				<el-breadcrumb separator-class="el-icon-arrow-right">
				  <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
				  <el-breadcrumb-item :to="{ path: '/product',query:{id:catid} }">产品介绍</el-breadcrumb-item>
				  <el-breadcrumb-item :to="{ path: '/product',query:{id:catid,index:index} }" v-if="detail.type_text&&index!==undefined">{{detail.type_text}}</el-breadcrumb-item>
				  <el-breadcrumb-item >{{detail.title}}</el-breadcrumb-item>
				</el-breadcrumb>
			</div>
		</div>
		
		<div class="newsDetailBox">
			<div class="productInfo">
        <div class="imgBox">
          <img :src="currentImg" alt="" class="imgBig">
          <div class="productImgBox">
            <img :src="$imgUrl.imgUrl(item)" alt="" v-for="(item,index) in imgsList" :key="index" @mouseenter="bigImg(item)" @mouseleave="reductionImg(item)" @click="bigImg2(item)">
          </div>
        </div>
        <div class="content">
          <div class="tagBox" v-if="tagsList">
            <div class="tags" v-for="(item,index) in tagsList" :key="index">{{item}}</div>
          </div>
          <div class="title textLinesLimit_1">{{detail.title}}</div>
          <div class="text">{{detail.keywords}}</div>
					<div class="share" v-if="isEn">
						<div class="shareTitle">
							<img class="shareIcon" src="../../src/img/share.png" alt="">
							<div class="shareText">Share To:</div>
						</div>
						<div class="iconBtnBox">
							<div class="iconBtn">
								<a :href="getShare(index)" v-for="(item,index) in iconList" :key="index" @mouseenter="iconImgChang(item,index)" @mouseleave="iconImgReduction(item,index)" target="_blank">
									<img :src="item.img" alt="">
								</a>
							</div>
						</div>
					</div>
					<div class="messageBtn" @click="msgBoxJump()">
						<div class="btnText">留言</div>
						<div class="icon"></div>
					</div>
        </div>
      </div>
      <div class="titleBox">产品详情</div>
			<p class="newsContern" v-html="detail.content"></p>
			<div class="msgBox" id="msgBox">
				<div class="msgTopBox">
					<img src="../../src/img/msg_btn_opt.png" alt="">
					<div>留言</div>
				</div>
				<div class="msgFormBox">
					<div class="hint">如果您对我们的产品感兴趣，想了解更多详情，请在此留言，我们会尽快回复您。</div>
					<el-form :model="formMsg" ref="formMsg">
						<div class="msgInputBox">
							<el-form-item prop="mail">
								<el-input v-model="formMsg.email" placeholder="你的邮件">
									<i slot="prefix" class="mail_icon"></i>
								</el-input>
							</el-form-item>
							<el-form-item prop="phone">
								<el-input v-model="formMsg.phone" placeholder="你的电话">
									<i slot="prefix" class="phone_icon"></i>
								</el-input>
							</el-form-item>
						</div>
						<el-form-item prop="content" class="contentBox">
							<img src="../../src/img/edit_desc_icon.png" alt="">
							<el-input type="textarea" v-model="formMsg.remark" placeholder="输入产品详细信息(如颜色、尺寸、材料等)和其他具体要求。以获得准确的报价。">
							</el-input>
						</el-form-item>
						<el-form-item>
							<el-button type="primary" @click="submitForm()">提交</el-button>
						</el-form-item>
					</el-form>
				</div>
			</div>
		</div>
	</div>
</template>
<style scoped>
.productInfo{display: flex;}
.productInfo .imgBox{width: 360px;}
.productInfo .imgBox .imgBig{display: inline-block;width: 100%;height: 360px;}
.productInfo .imgBox .productImgBox{display: flex;margin-bottom: 90px;margin-top:5px;}
.productInfo .imgBox .productImgBox img{width: 60px;height: 60px;background: #F5F5F5;border: 1px solid #E6E6E6;margin-right: 12.8px;cursor:pointer;}
.productInfo .imgBox .productImgBox img:last-child{margin-right: 0;}
.productInfo .imgBox .productImgBox img:hover{background: #FFFFFF;border: 1px solid #009144;}
.productInfo .content{padding-left: 90px;padding-top: 60px;box-sizing: border-box;}
.productInfo .content .tagBox{display: flex;flex-wrap: wrap;}
.productInfo .content .tagBox .tags{padding: 0 8px;box-sizing: border-box; font-size: 14px;font-weight: 400;color: #009144;line-height: 30px;margin-right: 16px;border: 1px solid #009144;border-radius: 6px;margin-bottom: 12px;}
.productInfo .content .title{font-size: 30px;font-weight: bold;color: #333333;line-height: 28px;}
.productInfo .content .text{margin-bottom:44px;margin-top:6px;font-size: 14px;font-weight: 400;color: #666666;line-height: 30px;}
.share{margin-bottom: 18px;}
.shareTitle{display: inline-block;vertical-align: middle;}
.shareIcon{margin-top: -3px;width: 18px;height: 21px;display: inline-block;vertical-align: middle;}
.shareText{margin-left: 6px;margin-right: 22px; display: inline-block;font-size: 16px;font-family: Microsoft YaHei;font-weight: 400;color: #000000;}
.iconBtnBox{display: inline-block;vertical-align: middle;}
.iconBtnBox .iconBtn{display: flex;}
.iconBtnBox .iconBtn a{margin-right: 14px;}
.iconBtnBox .iconBtn img{width: 38px;height: 38px;}
.titleBox{font-size: 18px;font-weight: bold;color: #000000;line-height: 30px;margin-bottom: 22px;}
.messageBtn{padding: 9px 26px;box-sizing: border-box; display: inline-block;background: #FFFFFF;border: 1px solid #009144;border-radius: 12px;}
.messageBtn .btnText{display: inline-block;vertical-align: middle; font-size: 14px;font-family: Microsoft YaHei;font-weight: 400;color: #009144;}
.messageBtn .icon{display: inline-block;vertical-align: middle; width: 22px;height: 19px;margin-left: 8px;content: url(../../src/img/msg_btn_no.png);}
.messageBtn:hover{background: #009144;border: 1px solid #009144;border-radius: 12px;}
.messageBtn:hover .btnText{color: #FFFFFF;}
.messageBtn:hover .icon{content: url(../../src/img/msg_btn_opt.png);}
/* .msgBox{} */
.msgTopBox{padding: 0 24px;box-sizing: border-box; height: 50px;line-height: 50px; background: #009144;box-shadow: 0px 4px 20px 1px rgba(120, 146, 132, 0.24);}
.msgTopBox img{margin-top:-8px; width: 22px;height: 20px;margin-right:7px;display: inline-block;vertical-align: middle;}
.msgTopBox div{font-size: 20px;font-weight: 400;color: #FFFFFF;display: inline-block;}
.msgFormBox{background: #F7F7F7;padding: 16px 24px;box-sizing: border-box;}
.msgFormBox .hint{font-size: 12px;font-weight: 400;color: #999999;}
.msgInputBox{margin-top:24px;}
.mail_icon{width: 18px;height: 18px; content: url(../../src/img/mail_icon.png);}
.phone_icon{width: 18px;height: 20px; content: url(../../src/img/phone_msg.png);}
.contentBox{position: relative;}
.contentBox img{width: 18px;height: 18px;position: absolute;top:10px;left:20px; z-index: 1;}
/deep/.msgFormBox .el-input--prefix .el-input__inner{padding-left:50px;}
/deep/.msgFormBox .el-input__prefix{left: 20px;line-height: 48px;}
/deep/.msgInputBox .el-form-item{display: inline-block; width: 286px;margin-right: 20px; height: 36px;}
/deep/.msgInputBox .el-form-item .el-input__inner{height: 36px;line-height: 36px; background: #FFFFFF;border: 1px solid #E6E6E6;border-radius: 18px;font-family: Microsoft YaHei;}
/deep/.msgFormBox .el-textarea__inner{font-size: 12px;padding: 10px 20px;border: 1px solid #E6E6E6;border-radius: 10px;text-indent : 30px; width: 587px;min-height: 160px!important;font-family: Microsoft YaHei;}
/deep/.msgFormBox input::-webkit-input-placeholder {color: #999999;font-size: 12px;font-family: Microsoft YaHei;}
/deep/.msgFormBox input:-moz-placeholder {color: #999999;font-size: 12px;font-family: Microsoft YaHei;}
/deep/.msgFormBox input:-ms-input-placeholder {color: #999999;font-size: 12px;font-family: Microsoft YaHei;}
/deep/.el-textarea input::-moz-input-placeholder {text-indent : 30px; color: #999999;font-size: 12px;font-family: Microsoft YaHei;}
/deep/.el-textarea__inner::-webkit-input-placeholder {text-indent : 30px; color: #999999;font-size: 12px;font-family: Microsoft YaHei;}
/deep/.el-button{background: #009144;border: 2px solid #009144;border-radius: 20px;}
</style>
<script>
import * as axios from '../../src/axios/api.js'
import imgUrl from '../../src/utils/imgUrl.js'
import * as timeData from '../../src/utils/DataUtils.js'
export default{
	data(){
		return{
			catid:'',
			maxscrollTop:false,
      detail:{},
			pImg:'',
			currentImg:'',
      tagsList:[
        
			],
			isEn:false,
      imgsList:[
        
			],
			formMsg: {
				email: '',
				phone: '',
				remark: ''
			},
			index:'',
			iconList:[],
			iconList2:[
				{
					img:require('../../src/img/f_no.png'),
					img_:require('../../src/img/f_opt.png'),
				},
				{			
					img:require('../../src/img/in_no.png'),
					img_:require('../../src/img/in_opt.png'),
				},
				{			
					img:require('../../src/img/twitter_no.png'),
					img_:require('../../src/img/twitter_opt.png'),
				},
				{			
					img:require('../../src/img/douyin_no.png'),
					img_:require('../../src/img/douyin_opt.png'),
				}
			],
		}
	},
	
	created() {
		var id=this.$route.query.id;
		var catid=this.$route.query.catid;
		this.catid=catid;
		this.index=this.$route.query.index;
		// 调用查询新闻列表接口
		this.getNewsDetailList(id,catid);
		this.iconList=JSON.parse(JSON.stringify(this.iconList2));
	},
    mounted() {
		window.addEventListener('scroll', this.handleScroll)
    },
	methods:{
		getNewsDetailList(id,catid){
			axios.get('/api/product/detail',{id:id,catid:catid}).then(res => {
				if(res.code==1){
					this.detail=res.data
					this.imgsList=res.data.image
					if(res.data.tags){
						this.tagsList=res.data.tags.split(",");
					}
					this.currentImg=imgUrl.imgUrl(res.data.image[0]);
					this.pImg=imgUrl.imgUrl(res.data.image[0]);
					// this.detail=res.data
					// this.detail.update_time=timeData.formatDate(this.detail.update_time);
				}
			});
		},
		 handleScroll () {
		   var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
		   if(scrollTop > 464){
			   this.maxscrollTop = true
		   }else{
			   this.maxscrollTop = false
		   }
     },
    bigImg(item){
      var that=this
      that.currentImg=imgUrl.imgUrl(item)
		},
		bigImg2(item){
      var that=this
      that.pImg=imgUrl.imgUrl(item)
		},
		reductionImg(){
			var that=this
			that.currentImg=imgUrl.imgUrl(that.pImg)
		},
		msgBoxJump(){
			var that = this;
      let jump = document.querySelector('#msgBox');
      let total = jump.offsetTop - 82;
      let distance =
        document.documentElement.scrollTop || document.body.scrollTop;
      // 平滑滚动，时长500ms，每10ms一跳，共50跳
      let step = total / 50;
      if (total > distance) {
        smoothDown();
      } else {
        let newTotal = distance - total;
        step = newTotal / 50;
        smoothUp();
      }
      function smoothDown() {
        if (distance < total) {
          distance += step;
          document.body.scrollTop = distance;
          document.documentElement.scrollTop = distance;
          setTimeout(smoothDown, 10);
        } else {
          document.body.scrollTop = total;
          document.documentElement.scrollTop = total;
        }
      }
      function smoothUp() {
        if (distance > total) {
          distance -= step;
          document.body.scrollTop = distance;
          document.documentElement.scrollTop = distance;
          setTimeout(smoothUp, 10);
        } else {
          document.body.scrollTop = total;
          document.documentElement.scrollTop = total;
        }
      }
		},
		iconImgChang(item,index){
			var that=this
			item.img=that.iconList2[index].img_
		},
		iconImgReduction(item,index){
			var that=this
			item.img=that.iconList2[index].img
		},
		getShare(index){
			var url='';
			var currentUrl=window.location.href
			if(index==0){
				url='https://www.facebook.com/sharer.php?u='+currentUrl
			}else if(index==1){
				url='http://www.linkedin.com/shareArticle?mini=true&url='+currentUrl
			}else if(index==2){
				url='https://twitter.com/intent/tweet?url='+currentUrl
			}else{
				url=''
			}
			return url;
		},
		submitForm(formName){
			axios.post('/api/message',this.formMsg).then(res => {
				if(res.code==1){
					this.$message({
						message: res.msg,
						type: 'success',
						offset:60,
					});
					this.formMsg=[];
				}
			});
		} 
	}
}
</script>